export default class BackupsController {
  constructor(ContentService, $uibModal, Notification, isMobile, ProfilePermissionsService, moment, FileSaver, Blob, $translate, AccountInformationService) {
    this.service = ContentService;
    this.modal = $uibModal;
    this.notify = Notification;
    this.isMobile = isMobile;
    this.permissionsService = ProfilePermissionsService;
    this.moment = moment;
    this.FileSaver = FileSaver;
    this.Blob = Blob;
    this.trans = $translate.instant;
    this.accountService = AccountInformationService;
  }

  $onInit() {
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;

    this.subscriptions.push(
      this.backups.subscribe(
        (backupList) => {
          this.backupList = backupList.map(i => {
            i.timestamp = this.moment.utc(i.timestamp).tz(
              this.accountService.timezone
            );
            return i;
          });
        },
        (error) => console.log("an error has ocurred")
      )
    );

    this.multipleDelete = [];
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  downloadBackup(backup) {
    const _ = this.trans;
    this.subscriptions.push(
      this.service.downloadBackup(backup.filename).subscribe(
        (data) => {
          var file = new this.Blob([data.data]);
          this.FileSaver.saveAs(file, backup.filename);
        },
        () => {
          this.notify.error(_("Ha ocurrido un error tratando de descargar el backup, intente nuevamente"));
        }
      )
    );
  }

  openModalBackup(){
    var that = this;
    var allowedExtensions = ['sav'];

    this.modal.open({
      animation: true,
      size: 'lg',
      templateUrl: 'upload-backup-template.html',
      appendClassName: 'ngdialog-theme-plain',
      controller: ($scope, $state, $uibModalInstance, FileUploader, host, AuthService, cfpLoadingBar, $translate) => {
        "ngInject";
        $scope.inMobileView = that.inMobileView;
        $scope.displayUploadedList = false;
        $scope.uploadedFiles = [];
        $scope.uploadingFiles = false;
        var _ = $translate.instant;
        var fileUploader = $scope.fileUploader = new FileUploader({
          url: host + '/api/accounts/backup-files',
          headers: {
            Authorization: 'Bearer ' + AuthService.getToken(),
            'X-Account-Token': AuthService.getAccountToken()
          },
          filters: [{
            name: 'allowedFile',
            fn: (item) => {
              return allowedExtensions.indexOf(item.name.toLowerCase().split('.').slice(-1)[0]) > -1;
            }
          }]
        });
        fileUploader.onSuccessItem = (item, response, status, headers) => {
          var uploadedItem = {
            id: response.id,
            filename: response.filename,
            filesize: response.filesize,
            title: response.title,
            timestamp: that.moment.utc(response.timestamp).tz(
              this.accountService.timezone
            )
          };
          $scope.uploadedFiles.push(uploadedItem);

          var foundAt = that.backupList.findIndex(i => i.filename === uploadedItem.filename);
          if (foundAt > -1) {
            that.backupList.splice(foundAt, 1, uploadedItem);
          } else {
            that.backupList.unshift(uploadedItem);
          }
          console.log("File successfully uploded");
        };
        fileUploader.onErrorItem = (item, response, status, headers) => {
          that.notify.error(_("Ha ocurrido un error tratando de subir los archivos, intente nuevamente"));
          console.log("An error happened while uploading file");
        };

        fileUploader.onProgressAll = (progress) => {
          cfpLoadingBar.set(progress / 100);
        };

        fileUploader.onCompleteAll = (item, response, status, headers) => {
          $scope.displayUploadedList = true;
          $scope.uploadingFiles = false;
          cfpLoadingBar.complete();
        };

        $scope.closeThisDialog = () => $uibModalInstance.close();
        $scope.uploadBackup = () => {
          if (fileUploader.queue.length > 0) {
            fileUploader.uploadAll();
            cfpLoadingBar.start();
            $scope.uploadingFiles = true;
          }
        };
        $scope.clearQueue = () => { fileUploader.clearQueue(); };
      }
    });
  }

  deleteBackup(backup) {
    this.subscriptions.push(
      this.service.deleteBackup(backup.id).subscribe(
        (resp) => {
          this.backupList.splice(this.backupList.indexOf(backup), 1);
        },
        (error) => {
          console.log(error);
        }
      )
    );
  }

  toggleCheckDelete(backup){
    if (this.multipleDelete.indexOf(backup) <= -1 ) {
      this.multipleDelete.push(backup);
    } else {
      this.multipleDelete.splice(this.multipleDelete.indexOf(backup), 1);
    }
  }

  deleteMultiplesBackups(){
    if(this.multipleDelete.length > 1 && this.permissionsService.hasPermission('remove-backup')){
      var backupIdList = this.multipleDelete.map((backup) => backup.id);
      this.subscriptions.push(
        this.service.deleteMultiplesBackups(backupIdList).subscribe(
          (data) => {
            this.notify.success(_('Sus Backups han sido eliminados exitosamente.'));
            for (var deleted of this.multipleDelete){
              this.backupList.splice(this.backupList.indexOf(deleted), 1);
            }
            this.multipleDelete = [];
          },
          (error) => this.notify.error(_('Ups, en estos momentos no podemos eliminar sus backups. Intente nuevamente.'))
        )
      );
    }
  }
}

 BackupsController.$inject = ['ContentService', '$uibModal', 'Notification', 'isMobile', 'ProfilePermissionsService', 'moment', 'FileSaver', 'Blob', '$translate', 'AccountInformationService'];


// WEBPACK FOOTER //
// ./src/app/pages/backups/backups.controller.js